// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pintura[data-v-69c48a45]{\n  width: 100%;\n  height: fit-content;\n}\n", ""]);
// Exports
module.exports = exports;
